/* istanbul ignore file */
import { createContext } from "react";

export const defaultSettings = {
  accTarievenOrigin: "",
  aovOrigin: "",
  applicationInsightsKey: "",
  asyncDebounce: "1",
  berekeningenFormsOrigin: "",
  googleAnalyticsTrackingCode: "",
  hdnKeuzelijstenOrigin: "",
  hdnDossierOrigin: "",
  hypotheekOrigin: "",
  hypotheekvergelijkerOrigin: "",
  hypotheekrentesOrigin: "",
  klantdossiersFormsOrigin: "",
  foundationOrigin: "",
  klantdossiersBemiddelingOrigin: "",
  kredietOrigin: "",
  licentiesOrigin: "",
  logOrigin: "",
  notificatiesOrigin: "",
  oauthAuthority: "",
  oauthClientId: "",
  OcpApimSubscriptionKey: "",
  opbouwOrigin: "",
  orvOrigin: "",
  postcodeOrigin: "",
  productenOrigin: "",
  azureFunctionCode: "",
  workflowOrigin: "",
  vermogenOrigin: "",
  passthroughOrigin: "",
  instellingenFormsOrigin: "",
  rapportageOrigin: "",
  supportZohoOrigin: "",
  findataimportfromapiOrigin: "",
  klantdossiersConversieOrigin: "",
  takenOrigin: "",
  signalRServiceOrigin: "",
  nieuwsOrigin: "",
  externeKoppelingenOrigin: "",
  externeKoppelingenAvailable: false,
  baseUrls: {
    ADV: "",
    POR: "",
    INS: "",
    BEM: "",
    PRD: "",
    BER: "",
    LIC: "",
    DOC: "",
    HDN: ""
  },
  oidcScopes: "",
  rapportageServiceBusOrigin: "",
  nationaleWaarborgApiOrigin: "",
  vertaalOrigin: "",
  captchaSiteKey: "",
  fdtaUrl: "",
  caching: {
    enabled: false,
    timeToLiveInSeconds: 1,
    methodsToCache: [""],
    pathsToCache: [""]
  }
};

export type SettingsType = typeof defaultSettings;

export const SettingsContext = createContext(defaultSettings);
